import Image from '@/features/shared/Image';
import { MuiButtonBase, MuiCard, MuiCardMedia } from '@/features/shared/material-ui';
import { mapLinkToProps } from '@/utils/helpers';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import useStyles from './CtaCard.styles';

const CtaCard = ({ cardImage, cardColor, className: overrideClassName }: any) => {
  const classes = useStyles({});
  const cardClassName = clsx(classes.bgCard, `bg-color-${cardColor}`, overrideClassName);
  const linkProps = useMemo(() => mapLinkToProps({ href: cardImage.url }), [cardImage.url]);
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  return (
    <>
      {cardImage && (
        <MuiCard elevation={8} className={cardClassName}>
          <MuiButtonBase {...linkProps} className={classes.button}>
            <MuiCardMedia className={classes.cardMedia}>
              <Image
                image={cardImage}
                size={!isMobile ? 'cover' : undefined}
                roundedCorners={false}
              />
            </MuiCardMedia>
          </MuiButtonBase>
        </MuiCard>
      )}
    </>
  );
};

export default memo(CtaCard);
